import React from 'react';
import { Box, Typography } from '@mui/material';
import SidebarNavItem from '../SidebarNavItem';

const SectionLabel = ({ label, sidebarCollapsed }) => {
  if (sidebarCollapsed) return null;

  return (
    <Typography
      sx={{
        fontSize: '0.6875rem',
        fontWeight: 500,
        color: 'rgba(255,255,255,0.45)',
        letterSpacing: '0.25em',
        px: '0.875rem',
        pt: '1.25rem',
        pb: '0.25rem',
        display: 'block',
        userSelect: 'none',
        textTransform: 'uppercase',
      }}
    >
      {label}
    </Typography>
  );
};

const SidebarNavigation = ({
  menuConfig,
  sidebarCollapsed,
  matchesUpMd,
  toggleDrawer,
}) => {
  const commonProps = {
    drawerToggle: !matchesUpMd ? toggleDrawer : undefined,
    collapsed: sidebarCollapsed,
  };

  // Section labels are dropped when every item in the section is permission-gated
  // away, so a collapsed-out section can't leave a heading floating on its own.
  const visible = (items) => items?.filter((item) => item?.permission !== false) ?? [];

  const sections = [
    { label: null, items: visible(menuConfig?.home) },
    { label: 'Manage', items: visible(menuConfig?.manage) },
    { label: 'Revenue', items: visible(menuConfig?.revenue) },
  ];

  return (
    <Box
      id="sidebar-scroller"
      sx={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
        pt: '0.25rem',
        pb: '0.25rem',
      }}
    >
      {sections.map(({ label, items }) => {
        if (items.length === 0) return null;

        return (
          <React.Fragment key={label ?? 'top'}>
            {label && (
              <SectionLabel label={label} sidebarCollapsed={sidebarCollapsed} />
            )}
            {items.map((item) => (
              <SidebarNavItem key={item.label} {...item} {...commonProps} />
            ))}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default SidebarNavigation;
